export const formateDate = (inputDate: string) => {
    const isDateOnly = !inputDate.includes('T');

    const fullDateTimeString = isDateOnly ? `${inputDate}T00:00:00Z` : inputDate;

    const dateObject = new Date(fullDateTimeString);

    if (isNaN(dateObject.getTime())) {
        return 'Invalid Date';
    }

    const year = dateObject.getUTCFullYear();
    const month = String(dateObject.getUTCMonth() + 1).padStart(2, '0');
    const day = String(dateObject.getUTCDate()).padStart(2, '0');

    return `${month}/${day}/${year}`;
};

